import React from 'react';
import '../App.css';
import { Container } from 'react-bootstrap';

const lifeText = [
  'Георгий Победоносец — святой, великомученик, один из самых почитаемых в России святых. Согласно преданию, он родился в III веке и с юных лет отличался мужеством и верностью вере.',
  'Когда начались гонения на христиан, Георгий открыто исповедал Христа, раздал имущество бедным и был подвергнут тяжёлым истязаниям. Несмотря на страдания, он сохранил стойкость и упование на Бога.',
  'Житие святого рассказывает о множестве испытаний, через которые он прошёл с твердостью духа. Его пример вдохновлял современников и многих людей, пришедших ко Христу.',
  'Перед казнью Георгий остался верен христианству до конца и принял мученическую смерть. Церковь чтит его как образец мужества, верности и духовной силы.'
];

function Khram() {
  return (
    <main className="page-main">
      <Container className="inner-page pb-5">
        <section className="section-block">
          <div className="section-heading">
            <h2>Святой великомученик Георгий Победоносец</h2>
            <p>
              Небесный покровитель прихода. Краткое житие святого приведено в назидание и для
              молитвенной памяти.
            </p>
          </div>

          <article className="surface-card article-page-card">
            {lifeText.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </article>
        </section>
      </Container>
    </main>
  );
}

export default Khram;
